import { getFunnel } from './getFunnel'
import { getJourneyById } from './getJourneyById'
import { getJourneys } from './getJourneys'

export const journeyService = {
  getJourneys,
  getJourneyById,
  getFunnel,
}

export * from './types'
